export default __webpack_public_path__ + "static/media/loader.6a4e9976.svg";